import {useSelector} from 'Provider';
import React from 'react';

import OfferFilterProperties from 'components/Offers/Filters/Properties';
import {OfferFiltersProperty} from 'models/OfferFilters';
import {
  nonMobileResultsByProperty,
  propertiesOfferCount,
} from 'store/offers/offers.selectors';

export interface OfferFilterPropertiesProps {
  list: OfferFiltersProperty[];
  selected?: OfferFiltersProperty[];
  onSelect?: (item: OfferFiltersProperty) => void;
  toggle?: boolean;
  onToggle?: () => void;
  onSelectAll?: () => void;
  availableProperties?: string[];
}

const ConnectedOfferFilterProperties: React.FC<OfferFilterPropertiesProps> = ({
  list,
  selected,
  onSelect,
  toggle,
  onToggle,
  onSelectAll,
  availableProperties,
}) => {
  const pOfferCount = useSelector(propertiesOfferCount);
  const totalPropertyOffersCount = useSelector(nonMobileResultsByProperty);

  return (
    <OfferFilterProperties
      list={list}
      selected={selected}
      onSelect={onSelect}
      toggle={toggle}
      onToggle={onToggle}
      onSelectAll={onSelectAll}
      availableProperties={availableProperties}
      propertiesOfferCount={pOfferCount}
      totalPropertyOffersCount={totalPropertyOffersCount}
    />
  );
};

export default ConnectedOfferFilterProperties;
